import React from 'react';
import {Calendar} from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';

const MyCalendar = props => {
  return <Calendar {...props} />;
};
export default MyCalendar;
